export default __webpack_public_path__ + "78de2cf211cd36f4294fc53df2317b29.svg";